import React from 'react';

import * as S from './NameChangeUI.styles';

import BreadCrumb from '../common/BreadCrumb/BreadCrumb';
import HeaderNameChange from './HeaderNameChange/HeaderNameChange';
import NameChangeInfoBlock from './NameChangeInfoBlock/NameChangeInfoBlock';

const NameChangeUI = ({tripDetails, submitChange}) => {
    return(
        <S.NameChangeUIMainWrap>
            <BreadCrumb />
            <S.NameChangeUIOuterWrap>
                <HeaderNameChange tripDetails={tripDetails}/>
                <NameChangeInfoBlock tripDetails={tripDetails} submitChange={submitChange}/>
            </S.NameChangeUIOuterWrap>
        </S.NameChangeUIMainWrap>
    )
}

export default NameChangeUI;